import type {
    Campaign, CreateCampaign, UpdateCampaign,
    Question, CreateQuestion, UpdateQuestion,
    CampaignSchedule, CreateCampaignSchedule, UpdateCampaignSchedule,
} from '@/models/feedback/Campaign';
import { feedbackRequest } from './feedbackClient';

export const campaignApi = {
    // Campaigns
    listCampaigns: (brandId: string) =>
        feedbackRequest<Campaign[]>(`feedback/campaigns?brandId=${brandId}`),
    getCampaign: (id: string) =>
        feedbackRequest<Campaign>(`feedback/campaigns/${id}`),
    createCampaign: (item: CreateCampaign) =>
        feedbackRequest<{ id: string }>(`feedback/campaigns`, { method: 'POST', body: JSON.stringify(item) }),
    updateCampaign: (id: string, item: UpdateCampaign) =>
        feedbackRequest<void>(`feedback/campaigns/${id}`, { method: 'PUT', body: JSON.stringify(item) }),
    deleteCampaign: (id: string) =>
        feedbackRequest<void>(`feedback/campaigns/${id}`, { method: 'DELETE' }),

    // Questions (brand-level, reusable across campaigns)
    listQuestions: (brandId: string) =>
        feedbackRequest<Question[]>(`feedback/questions?brandId=${brandId}`),
    getQuestion: (id: string) =>
        feedbackRequest<Question>(`feedback/questions/${id}`),
    createQuestion: (item: CreateQuestion) =>
        feedbackRequest<{ id: string }>(`feedback/questions`, { method: 'POST', body: JSON.stringify(item) }),
    updateQuestion: (id: string, item: UpdateQuestion) =>
        feedbackRequest<void>(`feedback/questions/${id}`, { method: 'PUT', body: JSON.stringify(item) }),
    deleteQuestion: (id: string) =>
        feedbackRequest<void>(`feedback/questions/${id}`, { method: 'DELETE' }),

    // Schedules (per campaign)
    listSchedules: (campaignId: string) =>
        feedbackRequest<CampaignSchedule[]>(`feedback/campaigns/${campaignId}/schedules`),
    getSchedule: (id: string) =>
        feedbackRequest<CampaignSchedule>(`feedback/campaigns/schedules/${id}`),
    createSchedule: (campaignId: string, item: CreateCampaignSchedule) =>
        feedbackRequest<{ id: string }>(`feedback/campaigns/${campaignId}/schedules`, { method: 'POST', body: JSON.stringify(item) }),
    updateSchedule: (id: string, item: UpdateCampaignSchedule) =>
        feedbackRequest<void>(`feedback/campaigns/schedules/${id}`, { method: 'PUT', body: JSON.stringify(item) }),
    deleteSchedule: (id: string) =>
        feedbackRequest<void>(`feedback/campaigns/schedules/${id}`, { method: 'DELETE' }),
};
